import { createReducer, on } from '@ngrx/store';
import { UiActions } from './ui.actions';
import { UiState, initialUiState } from './models/ui-state.models';

/**
 * UI Reducer
 * 
 * Handles all state transitions for UI features
 */
export const uiReducer = createReducer(
  initialUiState,
  
  // ========== Sidenav Actions ==========
  on(UiActions.toggleSidenav, (state) => ({
    ...state,
    sidenav: {
      isOpen: !state.sidenav.isOpen
    }
  })),
  
  on(UiActions.openSidenav, (state) => ({
    ...state,
    sidenav: {
      isOpen: true
    }
  })),
  
  on(UiActions.closeSidenav, (state) => ({
    ...state,
    sidenav: {
      isOpen: false
    }
  }))
);
